/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { SettingsPageAttackListSenderViewSettingItemAttackListSenderSettingFragmentDoc } from './SettingsPageAttackListSenderViewSettingItem.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
/** パートナー、子どもの存在を表すルールに使う */
export type AttackListSenderSettingRuleExistence =
  /** 存在する */
  | 'EXIST'
  /** 存在しない */
  | 'NOT_EXIST'
  /** 指定しない(存在してもしなくてもいい) */
  | 'NOT_SPECIFIED';

export type AttackListSenderSettingRuleGender =
  | 'FEMALE'
  | 'MALE'
  /** 性別は指定しない */
  | 'NOT_SPECIFIED';

export type FetchSettingsOnSettingsPageAttackListSenderViewQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchSettingsOnSettingsPageAttackListSenderViewQuery = { viewer: { attackListSender: { available: boolean, settings: Array<{ id: string, isEnabled: boolean, title: string, body: string, selections: Array<string>, entrance: { guid: string, name: string }, planner: { id: string, name: string }, rule: { partner: Types.AttackListSenderSettingRuleExistence, child: Types.AttackListSenderSettingRuleExistence, gender: Types.AttackListSenderSettingRuleGender, shouldSendIfSameCorporationApproached: boolean, savingRange: { min: number | null, max: number | null } | null, annualIncomeRange: { min: number | null, max: number | null } | null, familyAnnualIncomeRange: { min: number | null, max: number | null } | null, ageOfFirstChildRange: { min: number | null, max: number | null } | null, age: { min: number | null, max: number | null } | null, investmentRange: { min: number | null, max: number | null } | null } }> } } };

export type DeleteAttackListSenderSettingsMutationVariables = Exact<{
  ids: Array<string | number> | string | number;
}>;


export type DeleteAttackListSenderSettingsMutation = { deleteAttackListSenderSettings: { isSucceeded: boolean } };


export const FetchSettingsOnSettingsPageAttackListSenderViewDocument = gql`
    query FetchSettingsOnSettingsPageAttackListSenderView {
  viewer {
    attackListSender {
      available
      settings {
        ...SettingsPageAttackListSenderViewSettingItemAttackListSenderSetting
      }
    }
  }
}
    ${SettingsPageAttackListSenderViewSettingItemAttackListSenderSettingFragmentDoc}`;

/**
 * __useFetchSettingsOnSettingsPageAttackListSenderViewQuery__
 *
 * To run a query within a Vue component, call `useFetchSettingsOnSettingsPageAttackListSenderViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSettingsOnSettingsPageAttackListSenderViewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchSettingsOnSettingsPageAttackListSenderViewQuery();
 */
export function useFetchSettingsOnSettingsPageAttackListSenderViewQuery(options: VueApolloComposable.UseQueryOptions<FetchSettingsOnSettingsPageAttackListSenderViewQuery, FetchSettingsOnSettingsPageAttackListSenderViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchSettingsOnSettingsPageAttackListSenderViewQuery, FetchSettingsOnSettingsPageAttackListSenderViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchSettingsOnSettingsPageAttackListSenderViewQuery, FetchSettingsOnSettingsPageAttackListSenderViewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchSettingsOnSettingsPageAttackListSenderViewQuery, FetchSettingsOnSettingsPageAttackListSenderViewQueryVariables>(FetchSettingsOnSettingsPageAttackListSenderViewDocument, {}, options);
}
export function useFetchSettingsOnSettingsPageAttackListSenderViewLazyQuery(options: VueApolloComposable.UseQueryOptions<FetchSettingsOnSettingsPageAttackListSenderViewQuery, FetchSettingsOnSettingsPageAttackListSenderViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchSettingsOnSettingsPageAttackListSenderViewQuery, FetchSettingsOnSettingsPageAttackListSenderViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchSettingsOnSettingsPageAttackListSenderViewQuery, FetchSettingsOnSettingsPageAttackListSenderViewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchSettingsOnSettingsPageAttackListSenderViewQuery, FetchSettingsOnSettingsPageAttackListSenderViewQueryVariables>(FetchSettingsOnSettingsPageAttackListSenderViewDocument, {}, options);
}
export type FetchSettingsOnSettingsPageAttackListSenderViewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchSettingsOnSettingsPageAttackListSenderViewQuery, FetchSettingsOnSettingsPageAttackListSenderViewQueryVariables>;
export const DeleteAttackListSenderSettingsDocument = gql`
    mutation deleteAttackListSenderSettings($ids: [ID!]!) {
  deleteAttackListSenderSettings(ids: $ids) {
    isSucceeded
  }
}
    `;

/**
 * __useDeleteAttackListSenderSettingsMutation__
 *
 * To run a mutation, you first call `useDeleteAttackListSenderSettingsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttackListSenderSettingsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteAttackListSenderSettingsMutation({
 *   variables: {
 *     ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteAttackListSenderSettingsMutation(options: VueApolloComposable.UseMutationOptions<DeleteAttackListSenderSettingsMutation, DeleteAttackListSenderSettingsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteAttackListSenderSettingsMutation, DeleteAttackListSenderSettingsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteAttackListSenderSettingsMutation, DeleteAttackListSenderSettingsMutationVariables>(DeleteAttackListSenderSettingsDocument, options);
}
export type DeleteAttackListSenderSettingsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteAttackListSenderSettingsMutation, DeleteAttackListSenderSettingsMutationVariables>;